import { Component, Prop, Ref, SimpleEvent, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

@Component
export class QuantitySpinner extends ThemeComponent {
    @Prop({default: 1}) min!: number;
    @Prop({default: 9999}) max!: number;
    @Prop({attr: 'value'}) value!: number;

    @Ref() decreaseButton!: HTMLButtonElement;
    @Ref() increaseButton!: HTMLButtonElement;
    @Ref() input!: HTMLInputElement;

    protected rendering!: number;
    private _onChange = new SimpleEvent<number>();
    get onChange() {
        return this._onChange.asEvent();
    }

    public updateQuantity(quantity:number) {
        this.updateValue(quantity);
    }

    init() {
        this.$log.info('initing');
        this.$listen(this.increaseButton, 'click', () => this.increment());
        this.$listen(this.decreaseButton, 'click', () => this.decrement());
        this.render();
    }

    @Watch('rendering')
    private render() {
        this.input.value = (Math.min(this.max, Math.max(this.min, this.value))).toString();
        this._onChange.dispatch(this.value);
    }

    private updateValue(value: number) {
        this.value = value;
        this.rendering = this.value;
    }

    public increment() {
        this.value++;
        this.rendering = this.value;
    }

    public decrement() {
        this.value--;
        this.rendering = this.value;
    }
}
